var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MTooltip',{attrs:{"placement":"top"},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('a',_vm._g({attrs:{"href":"javascript:;"}},_vm.$listeners),[_c('MIcon',{attrs:{"name":"copy"}})],1)]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.$t('duplicate'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }